import React, { useEffect, useRef, useState } from 'react';
import { message } from 'antd';
import './CVReportGeneration.css';
import { isNonEmpty, useSessionState } from '../../utils';
import { useFillDocument, useGetDocuments } from '../../networking/useDocuments';
import Loading from '../../components/base/Loading';
import { SearchableDocViewer } from '../../components/document-utils/SearchableDocViewer';
import { Button } from '../../components/base/Button';
import { TextWithDropdown } from '../../components/base/TextWithDropdown';
import { FileList } from '../../components/pdf/FileList';
import { SourcesView } from '../../components/pdf/SourcesView';
import { MAX_COUNT_FILES_TO_CREATE } from '../../constants';
export const CVReportGenerationView = () => {
    const [cvDocuments, setCVDocuments] = useSessionState('CVDocuments', []);
    const [viewCVDocument, setCVViewDocument] = useState(null);
    const reviewPdfRef = useRef(null);
    const [cvReportDocuments, setCVReportDocuments] = useSessionState('cvReportDocuments', []);
    const [cvReportViewDocument, setCVReportViewDocument] = useState(null);
    const { isLoading: isLoadingCreate, statusCode, data: dataCreate, call: callCreateCVReport } = useFillDocument();
    const { isLoading, data: cvReportsResult, call: callGetCvReports, } = useGetDocuments({
        types: ['cv-report'],
    });
    useEffect(() => {
        if (cvReportsResult && isNonEmpty(cvReportsResult.items)) {
            setCVReportDocuments(cvReportsResult.items);
        }
    }, [cvReportsResult]);
    useEffect(() => {
        if (!statusCode)
            return;
        if (statusCode === 402) {
            message.error('Maximum allowance of credits reached. Payment needed. Contact founders@relyant.ai');
            return;
        }
        if (statusCode > 200) {
            message.error("Couldn't create a report. Contact founders@relyant.ai");
            return;
        }
        if (isNonEmpty(dataCreate)) {
            setCVReportDocuments((cvReportDocuments) => [...cvReportDocuments, ...dataCreate]);
        }
    }, [statusCode, dataCreate]);
    useEffect(() => {
        callGetCvReports();
    }, []);
    const onViewDocument = (document) => {
        setCVViewDocument(document);
    };
    const onDelete = (deleteResponse) => {
        setCVReportDocuments(cvReportDocuments.filter((doc) => !deleteResponse.includes(doc.id)));
    };
    return (React.createElement("div", { className: `reports-container split`, style: { height: '90vh' } },
        React.createElement("div", { className: "reports-section" }, isLoadingCreate || isLoading ? (React.createElement(Loading, { absolute: false })) : isNonEmpty(cvReportDocuments) ? (cvReportViewDocument ? (React.createElement(SearchableDocViewer, { document: cvReportViewDocument, onClose: () => setCVReportViewDocument(null) })) : (React.createElement("div", { className: "flex-column", style: {} },
            React.createElement(TextWithDropdown, { title: 'Candidate Reports' }),
            React.createElement("div", { style: { paddingTop: 24 } },
                React.createElement(FileList, { documents: cvReportDocuments, setDocuments: setCVReportDocuments, onViewDocument: setCVReportViewDocument, onDeleteFile: onDelete, fileEntryActions: ['view', 'download', 'delete'] }))))) : null),
        React.createElement("div", { ref: reviewPdfRef, className: "documents-section", style: {
                display: 'flex',
                flexGrow: 1,
                borderStyle: 'solid',
                borderWidth: 1,
                borderRight: 0,
                borderTop: 0,
                borderBottom: 0,
            } }, viewCVDocument ? (React.createElement(React.Fragment, null,
            React.createElement(SearchableDocViewer, { document: viewCVDocument, onClose: () => setCVViewDocument(null) }))) : (React.createElement(SourcesView, { title: "Candidate CVs", documents: cvDocuments, setDocuments: setCVDocuments, onViewDocument: onViewDocument, textUpload: "Upload Resumes here", showCheckbox: false, extractElements: false, actionButtons: [
                React.createElement(Button, { key: 'button-generate-reports', text: 'Generate Reports', onClick: () => {
                        const selectedDocs = cvDocuments.filter((doc) => !doc.isExcluded).map((doc) => doc.id);
                        if (selectedDocs.length > MAX_COUNT_FILES_TO_CREATE) {
                            message.error(`You can extract a maximum of ${MAX_COUNT_FILES_TO_CREATE} candidate reports at the same time.`);
                            return;
                        }
                        callCreateCVReport({
                            document_ids: selectedDocs,
                            company_slug: 'bluemont',
                        });
                    } }),
            ] })))));
};
